import React, { useEffect, useState } from 'react'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';
import LottiePlayer from "lottie-react";
import nodatafound from '../../../../../assets/animationicons/nodatafound.json'

const UserAnalyticReport = ({ moduleUUID }) => {
    const navigate = useNavigate();
    let params = useParams();
    const userData = useSelector((state) => state.userSlice);
    const configData = useSelector((state) => state.configSlice);
    let { groupId } = params;
    const [users, setUsers] = useState([]);

    let fetchUsers = async () => {
        try {
            var { data } = await axios.get(`${configData.config.UNO_URL}/api/user/list/${groupId}`, {
                headers: {
                    'Authorization': `Bearer ${userData.token}`
                }
            });
            setUsers(data.data);
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        fetchUsers()
    }, [groupId])

    const seeUserReport = async (uuid) => {
        navigate(`/module/report/user/${moduleUUID}`, { state: { userUUID : uuid }})
    }

    return (
        <>
            <div className="row px-2" >
                {
                    users.length > 0 ? users.map((user, index) => (
                        <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2 col-xxl-2 px-2" key={index}>
                            <div className='usercardesign' key={user.id}>
                                {user.avatar ? (
                                    <div className='avatarimg'>
                                        <img src={user.avatar} alt={`Avatar for ${user.name}`} title={user.name} referrerPolicy={'no-referrer'} />
                                    </div>
                                ) : (
                                    <div className='initials-placeholder'>
                                        {user?.name?.split(' ').map(word => word[0]).slice(0, 2).join('')}
                                    </div>
                                )}
                                <h6 className='groupname'>{user.name}</h6>
                                <p>{user.email}</p>

                                <button onClick={() => seeUserReport(user.uuid)} className='viewdetails'>User Report <ArrowForwardIosIcon /></button>
                            </div>
                        </div>
                    ))
                        :
                        <div className="text-center mt-5">
                            <LottiePlayer
                                animationData={nodatafound}
                                style={{ height: 200 }}
                                autoplay
                                loop
                            />
                            <h5>No User Found</h5>
                        </div>
                }
            </div>
        </>
    )
}

export default UserAnalyticReport
